
export enum ClaimStatusValue {
  Waiting = 'waiting',
  Accepted = 'accepted',
  Rejected = 'rejected',
}